// src/components/header/header.ts
import "./header.css";

export function initializeHeader(): void {
  const navToggle = document.getElementById("nav-toggle");
  const nav = document.getElementById("header-nav");

  if (!navToggle || !nav) return;

  const closeNav = () => {
    nav.classList.remove("nav-open");
    navToggle.setAttribute("aria-expanded", "false");
  };

  // Toggle nav on button click
  navToggle.addEventListener("click", () => {
    const isOpen = nav.classList.toggle("nav-open");
    navToggle.setAttribute("aria-expanded", String(isOpen));
  });

  // Close nav when clicking outside
  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;
    if (target.closest("#nav-toggle")) return;

    const clickedInNav = target.closest("#header-nav");
    if (!clickedInNav && nav.classList.contains("nav-open")) closeNav();
  });

  // Close nav on Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    closeNav();
  });
}
